import React, { useState, useCallback } from 'react'

import { bool, object } from 'prop-types'

import EarningsChart from 'Pods/Profile/Dashboard/MyStatisctics/Components/Earnings/EarningsChart'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

import EarningsTypeToggle from './EarningsTypeToggle'

function mergeChartData(regularData, subscriptionData) {
  const merged = {}
  const allKeys = new Set([
    ...Object.keys(regularData || {}),
    ...Object.keys(subscriptionData || {}),
  ])

  allKeys.forEach((key) => {
    merged[key] = (Number(regularData?.[key]) || 0) + (Number(subscriptionData?.[key]) || 0)
  })

  return merged
}

function getChartDataForType(earningsType, regularData, subscriptionData) {
  if (earningsType === 'subscription') return subscriptionData
  if (earningsType === 'regular') return regularData

  return mergeChartData(regularData, subscriptionData)
}

function EarningsSection({ isDataFetched, data, subscriptionChartData = EMPTY_OBJECT }) {
  const [earningsType, setEarningsType] = useState('total')

  const handleTypeChange = useCallback((type) => {
    setEarningsType(type)
  }, [])

  const chartData = isDataFetched
    ? getChartDataForType(earningsType, data?.earnings?.chart_data, subscriptionChartData)
    : null

  return (
    <div className="overview-earnings-chart">
      <div className="overview-earnings-chart__header">
        <span className="overview-earnings-chart__title">Earnings</span>
        <EarningsTypeToggle
          activeType={earningsType}
          onTypeChange={handleTypeChange}
        />
      </div>
      <div className="overview-earnings-chart__body">
        {chartData && <EarningsChart data={chartData} />}
      </div>
    </div>
  )
}

EarningsSection.propTypes = {
  isDataFetched: bool.isRequired,
  data: object.isRequired,
  subscriptionChartData: object,
}

export default EarningsSection
